// DOCUMENT READY
$( document ).ready( function(){
	//detect ios version
	function iOSversion() {
	  if (/iP(hone|od|ad)/.test(navigator.platform)) {
	    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
	    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
	    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
	  }
	}

	var ver = iOSversion();
    //if not iOS or it's version is higher than 8.4
	if (!ver || (ver[0] >= 8 && ver[1] > 4 && ver != null)) {
		$("body").addClass("css3");
	}else{
		$("body").addClass("noanimations");
	}


	//set first slide height
	var viewportHeight =  window.innerHeight;
	$("#first").css( "height", ""+viewportHeight+"px" );
	$("#last").css( "height", ""+viewportHeight+"px" );

	//define scrollTo function
	function scrollToThe(elementID){
		$('html,body').animate({
		   scrollTop: $("#"+elementID).offset().top
		});
	}

	/* find out more */
	$("#scroll-down-hint").on("click", function(){
		scrollToThe("second");
	});



	/* Login Form */

	//place cursor inside login form for better ux
	$("#login-form input:first").focus();

	//dealing with keyboard stuff
	$("#login-form input[type=password]").keyup(function (e) {
	    if (e.keyCode == 13) {
	        $("#login-form input.btn").focus();
	        $("#login-form input.btn").trigger("click");
	    }
	});

	$("#login-form input:first").keyup(function (e) {
	    if (e.keyCode == 13) {
	        $("#login-form input[type=password]").focus();
	    }
	});

	//wide version class in case if wrong pass
	if( $(".resetpassword-form").length > 0 ){
		$("body").addClass("wide");
	}

	//send form via post
	

	//throw errors
	$("#login-form .login input.btn").on('click', function () {
	    if ($("[id$='txtLoginEmail']").val().trim() == '' || $("[id$='txtLoginPassword']").val().trim() == '') { 
	        $("#login-form #login-errors").addClass("active");
	        return false;
		}
	});
	 
	//clear errors upon click and select one of the fields
	$("#login-form #login-errors").on('click', function () {
		if ($(".step-progress-container").is(':visible')) {
		}
		else {
			$(this).removeClass("active");
			$("#login-form input:first").select();
		}
	});





    /* Menu scroll to handling */
    var scrolling = false;
    $("#navbar .center a").each(function(index){
    	$(this).on( 'click', function(e){
    		e.preventDefault();
    		var destination = $(this).attr("href");
    		scrollToThe(destination);
    	});
    });

    //do this only when navbar is visible
    if( $("#navbar").css("display") != "none" ){
    	$("div.section").each(function(index){
    		var thisSection = $(this);
    		var triggerOffset = "30%";
    		if( thisSection.attr("id") == "first" ){
    			triggerOffset = -40;
    		}

    		if( thisSection.attr("id") == "last" ){
    			sectionHandler = function(direction){
    				setActiveMenuItem( thisSection.attr("id") );
    				if( direction == "down" ){
    					$("#contact-form input:first").focus();
    				}else{
    					$("#contact-form input:first").blur();
    				}
    			}
    		}


    		var sectionHandler = function(direction){
    			if( direction == "down" ){
    				setActiveMenuItem( thisSection.attr("id") );
    			}else{
    				setActiveMenuItem( thisSection.prev().attr("id") );
    			}
    		}
    		new Waypoint({
    			element: thisSection,
    			offset: triggerOffset,
    			handler: function(direction) {
    				sectionHandler(direction);
    			}
    		})

    	});
    }

	function setActiveMenuItem(id){
		$("#navbar .center a").removeClass("active");
		$("#navbar a[href="+id+"]").addClass("active");
	}

	//each section animation class assignment

	$(".section .visual").each(function(index){
		var thisVisual = $(this);
		var triggerOffset = "80%";
		new Waypoint({
			element: thisVisual,
			offset: triggerOffset,
			handler: function(direction) {
				if( direction == "down" ){
					$(thisVisual).addClass("active");
				}else{
					$(thisVisual).removeClass("active");
				}
				
			}
		})
	});

	$(".section .text").each(function(index){
		var thisText = $(this);
		var triggerOffset = "80%";
		new Waypoint({
			element: thisText,
			offset: triggerOffset,
			handler: function(direction) {
				if( direction == "down" ){
					$(thisText).addClass("active");
				}else{
					$(thisText).removeClass("active");
				}
				
			}
		})
	});
} );